import {
	getViemClients,
} from "@bracket/contractor-next";

import {
	getContractWithABI,
	isBlockHash,
	isAddress,
	type Address,
	type BlockHash,
	type ValidChainId,
} from "@bracket/chainography";

import bytes32 from "bytes32";

import type { Config } from "@wagmi/core";


export declare type ClaimWithdrawalProps = {
	shares: string;
	epoch: number;
	timestamp: number; // scheduled time in epoch seconds.
	salt?: string;
	salt_bytes?: string;
	vault: Address;

	chainId?: ValidChainId;
	config?: Config;
	attempt?: number;
	awaitReceipt?: boolean;
	timeout?: number;
}


export const claimWithdrawal = async ({
	vault,
	epoch,
	shares,
	timestamp,
	salt,
	salt_bytes,
	config,
	chainId = 1,
	awaitReceipt = true,
	timeout = 30000,
}: ClaimWithdrawalProps, ): Promise<BlockHash> => {
	try {

		if(!isAddress(vault))
			throw new Error("property vault should be a blockchain addresss");

		const [pclient, wclient] = await getViemClients({ chainId, config, });
		const [_, abi] = getContractWithABI("BracketVault", chainId);;
		const bShares = BigInt(shares);
		const bTimestamp = BigInt(timestamp);
		salt = salt_bytes || bytes32({ input: salt, });

		console.log("Transaction Report:", {
			address: vault,
			functionName: "claimWithdrawal",
			args: [
				bShares,
				epoch,
				bTimestamp,
				salt
			],
			account: wclient.account.address,
		});

		try {

			const {
				request,
				result,
			} = await pclient.simulateContract({
				address: vault,
				abi,
				functionName: "claimWithdrawal",
				args: [
					bShares,
					epoch,
					bTimestamp,
					salt
				],
				account: wclient.account,
			});

			const hash = await wclient.writeContract(request);

			if(isBlockHash(hash)) {
				await awaitReceipt ? pclient.waitForTransactionReceipt({ hash, timeout, }) : null;
				return hash;
			}
			throw new Error("expected result to be a bigint");
		}
		catch( err ) {
			console.log(err)
			throw new Error(`transaction failed - ${err.message}`)
		}
	}
	catch( err ) {
		throw new Error(`@bracket/contractor-next/bracket-vault/claimWithdrawal - ${err.message}`);
	}

}
